import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import { installConfirmModal } from "./confirm_modal";
import BoardController from "./controllers/board_controller";
import DetailsMenuController from "./controllers/details_menu_controller";
import IntegrationFilterFieldsController from "./controllers/integration_filter_fields_controller";
import LastWorkspaceController from "./controllers/last_workspace_controller";
import PrioritySliderController from "./controllers/priority_slider_controller";
import WorkflowSortController from "./controllers/workflow_sort_controller";
import WorkspaceSwitcherController from "./controllers/workspace_switcher_controller";

const application = Application.start();

installConfirmModal();

application.register("board", BoardController);
application.register("details-menu", DetailsMenuController);
application.register("integration-filter-fields", IntegrationFilterFieldsController);
application.register("last-workspace", LastWorkspaceController);
application.register("priority-slider", PrioritySliderController);
application.register("workflow-sort", WorkflowSortController);
application.register("workspace-switcher", WorkspaceSwitcherController);
